import { render, staticRenderFns } from "./GroupRegistrationPage.vue?vue&type=template&id=11119419"
import script from "./GroupRegistrationPage.vue?vue&type=script&lang=js"
export * from "./GroupRegistrationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports